import { motion } from 'framer-motion'
import style from './Team.module.css'
import Shreya from '../../../assets/images/Shreya.jpg'
import Seray from '../../../assets/images/SerayKocDisli.png'
import Mantas from '../../../assets/images/Mantas.jpeg'
import Nazar from '../../../assets/images/nazar.jpg'
import Abhinav from '../../../assets/images/abhinav.jpg'
import Anton from '../../../assets/images/anton.jpg'

const founders = [
  { name: 'Shreya Kohli', role: 'Founder', img: Shreya },
  { name: 'Abhinav Singh', role: 'Technical Architect', img: Abhinav },
]

const contributors = [
  { name: 'Anton Carlstedt', role: 'UX/UI Designer', img: Anton },
  { name: 'Mantas Navickis', role: 'Full-Stack Developer', img: Mantas },
  { name: 'Seray Koç', role: 'UX/UI Designer', img: Seray },
  { name: 'Nazar Tymiv', role: 'Full-Stack Developer', img: Nazar },
]

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
}

const MemberCard = ({ name, role, img, featured }) => (
  <motion.div
    className={`${style.card} ${featured ? style.featured : ''}`}
    variants={cardVariants}
    whileHover={{ y: -8, transition: { duration: 0.2 } }}
  >
    <div className={style.imgWrap}>
      <img src={img} alt={name} className={style.img} />
    </div>
    <div className={style.info}>
      <p className={style.name}>{name}</p>
      <span className={style.role}>{role}</span>
    </div>
  </motion.div>
)

const TeamSection = () => (
  <section id="team" className={style.section}>
    <motion.div
      className={style.header}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.55 }}
    >
      <span className={style.eyebrow}>The team</span>
      <h2 className={style.title}>Built by people who get it</h2>
      <p className={style.subtitle}>
        We've been where you are. Chimp exists because we wanted a better way.
      </p>
    </motion.div>

    <motion.div
      className={style.foundersGrid}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      transition={{ staggerChildren: 0.12 }}
    >
      {founders.map(m => <MemberCard key={m.name} {...m} featured />)}
    </motion.div>

    <motion.p
      className={style.groupLabel}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay: 0.1 }}
    >
      Contributors
    </motion.p>

    <motion.div
      className={style.contributorsGrid}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      transition={{ staggerChildren: 0.1 }}
    >
      {contributors.map(m => <MemberCard key={m.name} {...m} />)}
    </motion.div>
  </section>
)

export default TeamSection
